import { useMutation } from '@tanstack/react-query';

import type { DeleteParticipationArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: DeleteParticipationArgs) => {
  return employeeService.deleteParticipation(data);
};

export const useEmployeeDeleteParticipationMutation = () => {
  return useMutation<unknown, unknown, DeleteParticipationArgs>(mutationFn);
};
